import { render } from "./ChangePersonalInfos.vue?vue&type=template&id=c6965160&scoped=true&ts=true"
import script from "./ts/changePersonalInfo/changePersonalInfosHelper.ts?vue&type=script&lang=ts"
export * from "./ts/changePersonalInfo/changePersonalInfosHelper.ts?vue&type=script&lang=ts"

import "./ChangePersonalInfos.vue?vue&type=style&index=0&id=c6965160&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6965160"]])

export default __exports__